import { createRouter, createWebHistory } from "vue-router";

// @ts-expect-error - Virtual module from vite-plugin-pages
import generatedRoutes from 'virtual:generated-pages';

const router = createRouter({
    history: createWebHistory(),
    routes: generatedRoutes,
});

export default router;